import { ButtonType, CustomButton } from "soprasteria-ui-library/dist";
import * as React from "react";
import { useHistory } from 'react-router-dom';

export const NavigateBackFooter: React.FC = ({ }) => {
    const history = useHistory();

    return (
        <div className="card-footer">
            <div className="row">
                <div className="col-6 text-left">
                    <CustomButton buttonType={ButtonType.general} onClick={() => history.goBack()} buttonText="Gå tillbaka" />
                </div>
            </div>
        </div>
    )
}
